export enum GroupErrorCodes {
  GROUP_404 = 'GROUP_404',
}
